import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@fontsource/roboto";

import { Header } from "./components";
import GlobalStyle from "./globalStyles";
import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import Infractions from "./pages/Infractions/Infractions";
import { auth, isUserAdmin } from "./firebase/firebase-core";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import LocationViewer from "./pages/LocationViewer/LocationViewer";
import RemoveAccount from "./pages/RemoveAccount/RemoveAccount";

function App() {
  const [loading, setLoading] = useState(true);
  const [isAuth, setIsAuth] = useState<boolean>(false);

  useEffect(() => {
    async function checkAuth() {
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          const uid = user.uid;
          const admin = await isUserAdmin(uid);
          setIsAuth(admin);
        } else {
          // User is signed out
          setIsAuth(false);
        }
        setLoading(false);
      });
    }

    checkAuth();
  }, []);

  return (
    <BrowserRouter>
      <GlobalStyle />
      <Header isUserAuth={isAuth} />

      {loading && <h3>Aguarde...</h3>}

      {!loading && (
        <Routes>
          {!isAuth && <Route path="*" element={<Login />} />}
          {isAuth && <Route path="/" element={<Infractions />} />}

          <Route path="/removeAccount" element={<RemoveAccount />} />

          {/* <Route path="/M" element={<LocationViewer />} /> */}
          <Route path="/Home" element={<Home />} />
          <Route path="/login" element={<Login />} />
        </Routes>
      )}
    </BrowserRouter>
  );
}

export default App;
